export type Review = {
  id: string;
  productSlug: string;
  author: string;
  rating: number;
  date: string;
  comment: string;
  verified?: boolean;
  /** Kullanıcı fotoğrafı (UGC) */
  photo?: string;
};

export const reviews: Review[] = [
  { id: "1", productSlug: "qnail-builder-gel-50ml", author: "Elif K.", rating: 5, date: "2026-08-18", comment: "Akmadan sürülüyor, 3 haftadır kalkma yok. No:13 tonu tam doğal!", verified: true, photo: "/images/ugc/blush.jpg" },
  { id: "2", productSlug: "qnail-builder-gel-50ml", author: "Merve S.", rating: 4, date: "2026-08-10", comment: "Kıvamı koyu, acemiler biraz ince kat sürmeli. Kalıcılık çok iyi.", verified: true },
  { id: "3", productSlug: "uno-nail-prep-dehydrator", author: "Ayşe D.", rating: 5, date: "2026-08-12", comment: "Prep sonrası kalıcı ojem ilk kez 2 hafta dayandı, yağlı tırnağa birebir.", verified: true },
  { id: "4", productSlug: "qnail-inci-tozu-pigment", author: "Zeynep T.", rating: 5, date: "2026-08-15", comment: "Pigment inanılmaz, aplikatörle sürmesi çok kolay, tozutma yok.", verified: true, photo: "/images/ugc/chai.jpg" },
  { id: "5", productSlug: "uno-diamond-shield-top-coat", author: "Canan E.", rating: 4, date: "2026-08-09", comment: "Parlaklığı harika, sararma yapmadı. İnce sürmek önemli.", verified: true },
  { id: "6", productSlug: "qnail-uno-super-black-15ml", author: "Selin A.", rating: 5, date: "2026-08-22", comment: "Tek katta tam siyah, 10 gündür çıkmadı. Fırçası da düzgün.", verified: true, photo: "/images/ugc/kiraz.jpg" },
  { id: "7", productSlug: "qnail-soft-gel-tips-oval-medium-550", author: "Deniz Y.", rating: 5, date: "2026-08-25", comment: "Oval formu doğal duruyor, kutuda her bedenden bolca var.", verified: true, photo: "/images/ugc/uzum.jpg" },
];

export function getReviewsBySlug(slug: string): Review[] {
  return reviews.filter((r) => r.productSlug === slug);
}

export function getAverageRating(slug: string): { avg: number; count: number } {
  const list = getReviewsBySlug(slug);
  if (list.length === 0) return { avg: 0, count: 0 };
  const avg = list.reduce((s, r) => s + r.rating, 0) / list.length;
  return { avg: Number(avg.toFixed(1)), count: list.length };
}

/** Slug'u uint32'ye hash'ler (FNV-1a) — SSR + client'ta aynı sonucu verir. */
function hashSlug(slug: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < slug.length; i++) {
    h ^= slug.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}

/**
 * Gerçek yorumu olmayan ürünler için "insansı" placeholder istatistik.
 * Her ürün slug'ına göre deterministik ama farklı sayı üretir:
 * - count: 19..187 arası (hep 202 gibi sabit durmaz, 202'yi hiç üretmez)
 * - avg: 4.2..4.8 arası tek ondalık (hep 4.0 durmaz)
 * Gerçek yorum gelince kullanılmaz — sadece vitrin yıldız/sayaçları için.
 */
export function getFallbackReviewStats(slug: string): { avg: number; count: number } {
  const h = hashSlug(slug || "urun");
  const count = 19 + (h % 169); // 19..187
  const avgTable = [4.2, 4.3, 4.4, 4.5, 4.6, 4.7, 4.8, 4.4, 4.5, 4.6, 4.3, 4.7, 4.5, 4.4];
  const avg = avgTable[(h >>> 8) % avgTable.length] ?? 4.5;
  return { avg, count };
}

/**
 * Vitrinde gösterilecek istatistik: gerçek varsa gerçek, yoksa slug-bazlı fallback.
 * Kart yıldızları, PDP başlığı ve özet kutusu bunu kullanmalı ki
 * tüm ürünlerde aynı "202" görünmesin.
 */
export function getDisplayRating(slug: string): { avg: number; count: number } {
  const real = getAverageRating(slug);
  if (real.count > 0) return real;
  return getFallbackReviewStats(slug);
}
